import iconsList from "@/genIcons.js";
import html2Element from "@/utils/html2Element.js";

export default function applyIcons() {
    setTimeout(function () {
        const iconElements = document.querySelectorAll('[data-icon]');

        iconElements.forEach(async (element) => {
            const iconName = element.dataset["icon"];

            if (!iconName) {
                console.log(element);
                throw new Error("No icon name");
            }

            const iconContent = iconsList[iconName];

            if (!iconContent) {
                console.log(element);
                throw new Error("Unknown icon: " + iconName);
            }

            const newElement = html2Element(iconContent)

            element.parentNode.insertBefore(newElement, element);
            element.remove();

            for (const c of element.classList) {
                newElement.classList.add(c);
            }
        });

        const iconInsideElements = document.querySelectorAll('[data-icon-inside]');

        iconInsideElements.forEach(async (element) => {
            const iconName = element.dataset["iconInside"];

            if (!iconName) {
                console.log(element);
                throw new Error("No icon name");
            }

            const iconContent = iconsList[iconName];

            if (!iconContent) {
                console.log(element);
                throw new Error("Unknown icon: " + iconName);
            }

            element.innerHTML = iconContent;
        });
    }, 100);
}
